import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
  CircularProgress,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  Grow,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import axios from 'axios';

const VerifyEmailUserDirect = () => {
  const { token } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const res = await axios.get(`/api/user/verify-email/${token}`);
        if (res.data.success) {
          setSuccess(true);
        } else {
          setSuccess(false);
          setErrorMessage(
            res.data.error ||
              'Questo link è scaduto o già usato. Richiedi una nuova email di conferma.'
          );
        }
      } catch (err) {
        setSuccess(false);
        if (err.response && err.response.status === 404) {
          setErrorMessage(
            'Questo link è scaduto o già usato. Richiedi una nuova email di conferma.'
          );
        } else {
          setErrorMessage(err.message || 'Errore imprevisto');
        }
      } finally {
        setLoading(false);
      }
    };

    if (token) confirmEmail();
    else {
      setSuccess(false);
      setErrorMessage('Token mancante');
      setLoading(false);
    }
  }, [token]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
      px={2}
    >
      <Card
        elevation={3}
        sx={{
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
          borderRadius: 3,
          p: 2,
        }}
      >
        <CardContent>
          {loading && (
            <>
              <CircularProgress size={60} />
              <Typography variant="h6" mt={3}>
                Verifica in corso...
              </Typography>
            </>
          )}

          {!loading && (
            <Grow in timeout={700}>
              <Box>
                {success ? (
                  <>
                    <CheckCircleIcon sx={{ fontSize: 70, color: 'success.main' }} />
                    <Typography variant="h5" mt={2} color="success.main">
                      Email verificata con successo!
                    </Typography>
                    <Typography variant="body2" mt={1} color="text.secondary">
                      Ora puoi accedere al tuo account.
                    </Typography>
                  </>
                ) : (
                  <>
                    <ErrorOutlineIcon sx={{ fontSize: 70, color: 'error.main' }} />
                    <Typography variant="h6" mt={2} color="error">
                      {errorMessage}
                    </Typography>
                  </>
                )}

                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 4, borderRadius: 2, px: 4 }}
                  onClick={() => history.push('/signin')}
                >
                  Vai al login
                </Button>
              </Box>
            </Grow>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default VerifyEmailUserDirect;
